package components.project.configuration.layout.moduleLayout

import it.neckar.commons.kotlin.js.getNotNull
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.open.unit.si.mm
import it.neckar.react.common.*
import it.neckar.react.common.form.*
import react.*
import react.dom.*

/**
 * Form for module insets
 */
fun RBuilder.moduleLayoutInsetsForm(
  suggestedRoofInsetsLeft: StateInstance<@mm Int>,
  suggestedRoofInsetsRight: StateInstance<@mm Int>,
  suggestedRoofInsetsTop: StateInstance<@mm Int>,
  suggestedRoofInsetsBottom: StateInstance<@mm Int>,
  editableStatus: EditableStatus,
): Unit = child(moduleLayoutInsetsForm) {
  attrs {
    this.suggestedRoofInsetsLeft = suggestedRoofInsetsLeft
    this.suggestedRoofInsetsRight = suggestedRoofInsetsRight
    this.suggestedRoofInsetsTop = suggestedRoofInsetsTop
    this.suggestedRoofInsetsBottom = suggestedRoofInsetsBottom
    this.editableStatus = editableStatus
  }
}

val moduleLayoutInsetsForm: FC<ModuleLayoutInsetsFormProps> = fc("moduleLayoutInsetsForm") { props ->
  val suggestedRoofInsetsLeft = props::suggestedRoofInsetsLeft.getNotNull()
  val suggestedRoofInsetsRight = props::suggestedRoofInsetsRight.getNotNull()
  val suggestedRoofInsetsTop = props::suggestedRoofInsetsTop.getNotNull()
  val suggestedRoofInsetsBottom = props::suggestedRoofInsetsBottom.getNotNull()

  val editableStatus = props::editableStatus.safeGet()

  div("row gx-0 mt-3") {
    div("col-sm-6") {
      h5 { +"Mindestabstände Dachrand" }
    }
  }

  div("row gx-0") {
    div("col-sm-3") {
      div("input-group") {
        floatingIntInputField(
          valueAndSetter = suggestedRoofInsetsLeft,
          fieldName = "suggestedRoofInsetsLeft",
          title = "Links",
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedRight()
          }
        }

        span("input-group-text") {
          +"cm"
        }
      }
    }
    div("col-sm-3") {
      div("input-group") {
        floatingIntInputField(
          valueAndSetter = suggestedRoofInsetsRight,
          fieldName = "suggestedRoofInsetsRight",
          title = "Rechts",
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedLeft()
            mergedRight()
          }
        }

        span("input-group-text") {
          +"cm"
        }
      }
    }

    div("col-sm-3") {
      div("input-group") {
        floatingIntInputField(
          valueAndSetter = suggestedRoofInsetsTop,
          fieldName = "suggestedRoofInsetsTop",
          title = "Oben",
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedRight()
            mergedLeft()
          }
        }

        span("input-group-text") {
          +"cm"
        }
      }
    }

    div("col-sm-3") {
      div("input-group") {
        floatingIntInputField(
          valueAndSetter = suggestedRoofInsetsBottom,
          fieldName = "suggestedRoofInsetsBottom",
          title = "Unten",
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedLeft()
          }
        }

        span("input-group-text") {
          +"cm"
        }
      }
    }
  }
}

external interface ModuleLayoutInsetsFormProps : Props {
  var suggestedRoofInsetsLeft: StateInstance<@mm Int>
  var suggestedRoofInsetsRight: StateInstance<@mm Int>
  var suggestedRoofInsetsTop: StateInstance<@mm Int>
  var suggestedRoofInsetsBottom: StateInstance<@mm Int>
  var editableStatus: EditableStatus
}

